import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { arrayOf, func, shape, string } from 'prop-types';
import { SubscriptionForm as SubscriptionFormComp } from '../../molecules';
import { Container, Line, InfoLink, MultiColorHorizontalRule, PaymentMethods, CertificatePartners, SubscriptionForm, LinksNav } from './footer.styles';
import { ContactSection } from './subcomponents';
import { renderCertificatePartnersTitle, renderLinkContent } from './helpers';

function Footer({
  data,
  onSubmitSubscriptionForm,
  onMenuItemClick,
  onPaymentMethodClick,
  onCertificateClick
}) {
  var _paymentMethods$list, _certificatePartners$, _bottomInfo$texts, _bottomInfo$links;

  const {
    paymentMethods = {},
    certificatePartners = {},
    linksColumns = [],
    contactSection = {},
    bottomInfo = {},
    subscriptionForm
  } = data;
  return /*#__PURE__*/React.createElement(Container, {
    "data-testid": "footer-elem"
  }, /*#__PURE__*/React.createElement(Container.ContentWrapper, null, /*#__PURE__*/React.createElement(MultiColorHorizontalRule, {
    size: 5,
    position: "relative"
  }), /*#__PURE__*/React.createElement(Container.Content, null, paymentMethods && /*#__PURE__*/React.createElement(PaymentMethods, {
    "data-testid": "payment-methods-container",
    href: paymentMethods.link
  }, /*#__PURE__*/React.createElement(PaymentMethods.Content, null, /*#__PURE__*/React.createElement(PaymentMethods.Title, null, paymentMethods.label), /*#__PURE__*/React.createElement(PaymentMethods.MethodsContainer, null, /*#__PURE__*/React.createElement(PaymentMethods.MethodsContent, null, (_paymentMethods$list = paymentMethods.list) == null ? void 0 : _paymentMethods$list.map((item, idx) => /*#__PURE__*/React.createElement(PaymentMethods.Method, {
    "data-testid": "payment-option",
    key: idx
  }, /*#__PURE__*/React.createElement(PaymentMethods.MethodImage, {
    onClick: e => onPaymentMethodClick(e, {
      title: item.title
    }),
    src: item.img,
    alt: item.title
  }))))))), /*#__PURE__*/React.createElement(CertificatePartners, null, /*#__PURE__*/React.createElement(CertificatePartners.CertificatesContainer, null, /*#__PURE__*/React.createElement(CertificatePartners.CertificatesContent, null, renderCertificatePartnersTitle(certificatePartners.title, onCertificateClick), certificatePartners == null ? void 0 : (_certificatePartners$ = certificatePartners.certificates) == null ? void 0 : _certificatePartners$.map((item, idx) => {
    return /*#__PURE__*/React.createElement("li", {
      "data-testid": "certificate-partner",
      key: idx
    }, renderLinkContent(item, onCertificateClick));
  }), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    id: "seloEbit",
    href: "http://www.ebit.com.br/552",
    rel: "noreferrer",
    target: "_blank",
    "data-noop": "redir(this.href);"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("div", {
    id: "reputation-ra"
  }))))), subscriptionForm && /*#__PURE__*/React.createElement(SubscriptionForm, null, /*#__PURE__*/React.createElement(SubscriptionForm.Content, null, /*#__PURE__*/React.createElement(SubscriptionFormComp, _extends({
    onSubmitForm: onSubmitSubscriptionForm
  }, subscriptionForm)))), /*#__PURE__*/React.createElement(LinksNav, null, /*#__PURE__*/React.createElement(LinksNav.SectionsList, null, linksColumns.map((column, colIndex) => /*#__PURE__*/React.createElement(LinksNav.Column, {
    "data-testid": "link-column",
    key: colIndex
  }, column.map((section, sectionIndex) => {
    const linksList = section.links;
    return /*#__PURE__*/React.createElement("div", {
      "data-testid": "link-section",
      key: sectionIndex
    }, /*#__PURE__*/React.createElement(LinksNav.SectionTitle, null, section.title), /*#__PURE__*/React.createElement(LinksNav.LinksList, null, linksList.map((link, idy) => /*#__PURE__*/React.createElement(LinksNav.LinkItem, {
      "data-testid": `link-item-${idy}`,
      key: `${section}-${idy}`,
      onClick: e => onMenuItemClick(e, link, section == null ? void 0 : section.title)
    }, renderLinkContent(link)))));
  }))), contactSection && /*#__PURE__*/React.createElement(LinksNav.Column, {
    "data-testid": "link-column"
  }, /*#__PURE__*/React.createElement(LinksNav.SectionTitle, null, contactSection.label), /*#__PURE__*/React.createElement(ContactSection, contactSection)))))), /*#__PURE__*/React.createElement(Container.Bottom, null, /*#__PURE__*/React.createElement(Container.BottomContent, null, (_bottomInfo$texts = bottomInfo.texts) == null ? void 0 : _bottomInfo$texts.map((item, idx) => /*#__PURE__*/React.createElement(Line, {
    key: idx,
    "data-testid": "bottom-info-text-line"
  }, item)), (_bottomInfo$links = bottomInfo.links) == null ? void 0 : _bottomInfo$links.map((item, idx) => /*#__PURE__*/React.createElement(Line, {
    key: idx,
    "data-testid": "bottom-info-link-line"
  }, item.label, ": ", /*#__PURE__*/React.createElement(InfoLink, {
    href: item.url
  }, item.url))))));
}

const linkProps = process.env.NODE_ENV !== "production" ? shape({
  url: string.isRequired,
  title: string,
  content: arrayOf(shape({
    iconId: string,
    label: string,
    img: string
  }))
}) : {};
process.env.NODE_ENV !== "production" ? Footer.propTypes = {
  data: shape({
    certificatePartners: shape({
      title: shape({
        url: string,
        title: string,
        label: string
      }),
      certificates: arrayOf(linkProps).isRequired
    }).isRequired,
    linksColumns: arrayOf(arrayOf(shape({
      title: string,
      links: arrayOf(linkProps)
    }))).isRequired,
    contactSection: shape({}).isRequired,
    bottomInfo: shape({
      texts: arrayOf(string),
      links: arrayOf(linkProps)
    }).isRequired,
    paymentMethods: shape({
      label: string,
      link: string,
      list: arrayOf(linkProps)
    }),
    subscriptionForm: shape({
      iconId: string,
      title: string,
      policy: linkProps
    })
  }),
  onSubmitSubscriptionForm: func,
  onMenuItemClick: func,
  onCertificateClick: func,
  onPaymentMethodClick: func
} : void 0;
Footer.defaultProps = {
  data: {
    certificatePartners: {},
    linksColumns: [],
    contactSection: {},
    bottomInfo: {}
  },
  onMenuItemClick: null,
  onCertificateClick: null,
  onPaymentMethodClick: null
};
export default Footer;